import type React from "react";
type CSSProperties = React.CSSProperties;

interface StyleObject {
  [key: string]: string | number | undefined | StyleObject;
}

// Convert Panda CSS-like properties to React inline styles
export function css(styles: StyleObject): CSSProperties {
  const result: CSSProperties = {};

  for (const [key, value] of Object.entries(styles)) {
    if (value === undefined) continue;
    if (typeof value === "object") continue;

    // Convert Panda CSS properties to React CSS properties
    // Convert camelCase to kebab-case for CSS properties
    const cssKey = key.replace(
      /([A-Z])/g,
      (match) => `-${match.toLowerCase()}`
    );

    // Handle special Panda CSS tokens
    if (typeof value === "string") {
      result[cssKey as keyof CSSProperties] = value as any;
    } else {
      result[cssKey as keyof CSSProperties] = value as any;
    }
  }

  return result;
}

// Flex pattern helper
export function flex(
  options: {
    direction?: "row" | "column" | "row-reverse" | "column-reverse";
    align?: "start" | "center" | "end" | "stretch" | "baseline";
    justify?: "start" | "center" | "end" | "between" | "around" | "evenly";
    gap?: string | number;
    wrap?: "wrap" | "nowrap" | "wrap-reverse";
  } = {}
): CSSProperties {
  const alignMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    stretch: "stretch",
    baseline: "baseline",
  };

  const justifyMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    between: "space-between",
    around: "space-around",
    evenly: "space-evenly",
  };

  return {
    display: "flex",
    flexDirection: options.direction || "row",
    alignItems: options.align ? alignMap[options.align] : undefined,
    justifyContent: options.justify ? justifyMap[options.justify] : undefined,
    gap: options.gap,
    flexWrap: options.wrap,
  };
}
